import { jsxs as c, jsx as l } from "react/jsx-runtime";
import { u as r } from "./index-6a632112.mjs";
import { s as n, Q as m, h as t, a as d } from "./themes-5f0b3c3d.mjs";
import { f as g } from "./fontWeights-a25f8f91.mjs";
import { l as h } from "./lineHeights-72d3110c.mjs";
import { t as x } from "./textStyles-42cab346.mjs";
import { a as u, b as $, c as y } from "./superScript-393c70dc.mjs";
import "react";
import { h as T } from "./hTag-40b23797.mjs";
const S = r.div`
  ${u()}
  ${$()}
  display: flex;
  flex-direction: column;
  row-gap: ${n["6x"]};
  justify-content: space-around;
  padding: 0px ${n["5x"]};

  @media ${m.laptopAndUp} {
    padding: 0px;
  }
`, L = r.div`
  display: flex;
  flex-direction: column;
  ${({ $showButtonGroup: e, $alignment: i }) => `
    gap: ${!e && i === "center" ? n["1x"] : n["3x"]};
    align-items: ${i === "center" ? "center" : "unset"};
    text-align: ${i === "center" ? "center" : "unset"};
  `}
`, z = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, v = r(T)`
  font-family: ${(e) => e.theme.components.featureText.primaryFont};
  font-weight: ${t.XL.fontWeight};
  color: ${(e) => e.theme.components.featureText.titleColor};
  font-size: ${({ $titleSize: e }) => e === "large" ? t.L.fontSize : e === "xxLarge" ? t.XXL.fontSize : t.XL.fontSize};
  line-height: ${({ $titleSize: e }) => e === "large" ? t.L.lineHeight : e === "xxLarge" ? t.XXL.lineHeight : t.XL.lineHeight};
`, X = r.div`
  ${z()}
  ${y()}
  color: ${(e) => e.theme.components.featureText.descriptionColor};
  font-family: ${(e) => e.theme.components.featureText.secondaryFont};
  font-size: ${d.small};
  font-style: normal;
  font-weight: ${g.body.regular};
  font-size: ${x.body.regular.m.fontSize};
  line-height: ${h.medium};
`, b = r.div`
  display: flex;
  gap: ${n["4x"]};
  flex-direction: column;

  @media ${m.tabletAndUp} {
    flex-direction: row;
    gap: ${n["6x"]};
    justify-content: ${({ $alignment: e }) => e === "center" ? "center" : "unset"};
  }
`, D = ({
  title: e,
  children: i,
  actionButtons: o,
  titleProp: a = { title: "Title", headingLevel: "h1", size: "large" },
  description: s,
  alignment: p = "left",
  ...f
}) => /* @__PURE__ */ c(S, { ...f, children: [
  /* @__PURE__ */ c(
    L,
    {
      $showButtonGroup: !!o,
      $alignment: p,
      children: [
        /* @__PURE__ */ l(v, { as: a.headingLevel, $titleSize: a.size, children: a.title }),
        s && /* @__PURE__ */ l(X, { children: s })
      ]
    }
  ),
  o && /* @__PURE__ */ l(b, { $alignment: p, children: o })
] });
export {
  D as F
};
